import { render } from "./DailyDiffRow.vue?vue&type=template&id=08d82790&scoped=true&ts=true"
import script from "./DailyDiffRow.vue?vue&type=script&lang=ts"
export * from "./DailyDiffRow.vue?vue&type=script&lang=ts"

import "./DailyDiffRow.vue?vue&type=style&index=0&id=08d82790&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d82790"]])

export default __exports__